import React from "react";
import GenericRuleLogTable from "./GenericRuleLogTable";
import useRuleLogs from "./useRuleLogs";

const LandingRuleLogTable = ({ refreshKey }) => {
  const { rows, loading } = useRuleLogs("landing", refreshKey);
  return <GenericRuleLogTable rows={rows} loading={loading} />;
};

export default LandingRuleLogTable;
